import Ru from 'core/ui/icons/flags/ru.svg';
import De from 'core/ui/icons/flags/de.svg';
import En from 'core/ui/icons/flags/en.svg';
import Ua from 'core/ui/icons/flags/ua.svg';

import { capitalize } from 'lodash';

import { fromEntries } from './object';

export const LANGUAGES: TLang[] = Object.values(TLang);

type TIcon = typeof Ru;
const flags: Record<TLang, TIcon> = {
  [TLang.ru]: Ru,
  [TLang.en]: En,
  [TLang.de]: De,
  [TLang.ua]: Ua,
};

const intlCurrent = new Intl.DisplayNames([navigator.language], {
  type: 'language',
});

const REMAP: Partial<Record<TLang, string>> = { [TLang.ua]: 'uk' };

export type TLangData = {
  id: TLang;
  icon: TIcon;
  nativeName: string;
  localizedName: string;
};

export const LANGUAGES_DATA = fromEntries<TLang, TLangData>(
  LANGUAGES.map((lang): [TLang, TLangData] => [
    lang,
    {
      id: lang,
      icon: flags[lang],
      nativeName: capitalize(
        new Intl.DisplayNames([REMAP[lang] ?? lang], {
          type: 'language',
        }).of(REMAP[lang] ?? lang)
      ),
      localizedName: capitalize(intlCurrent.of(REMAP[lang] ?? lang)),
    },
  ])
);
